module.exports = __webpack_public_path__ + "852c95de4c7097c658b19796add09404.png";